(() => {
  document.querySelectorAll('[data-cut-product]').forEach(root => {
    const q = s => root.querySelector(s);
    const select = q('[data-cut-variant]'), input = q('[data-cut-length]'), submit = q('[data-cut-submit]');
    const thickness = q('[data-cut-thickness]'), rollWidth = q('[data-cut-width]');
    const money = p => new Intl.NumberFormat('en-GB', {style:'currency',currency:root.dataset.currency || 'GBP'}).format(p / 100);
    const minimum = Number(root.dataset.minCm), maximum = Number(root.dataset.maxCm), step = 10;
    function update() {
      const match = [...select.options].find(o => o.dataset.thickness === thickness.value && o.dataset.widthLabel === rollWidth.value);
      select.value = match?.value || '';
      for (const option of rollWidth.options) {
        option.disabled = ![...select.options].some(o => o.dataset.thickness === thickness.value && o.dataset.widthLabel === option.value && o.dataset.available === 'true');
      }
      const opt = select.selectedOptions[0], cm = Number(input.value);
      const width = Number(opt?.dataset.width);
      const valid = input.value.trim() !== '' && Number.isInteger(cm) && cm >= minimum && cm <= maximum && cm % step === 0 && width > 0 && opt?.dataset.available === 'true';
      const price = Number(opt?.dataset.price || 0), area = width * cm / 100;
      q('[data-cut-area]').textContent = valid ? `One continuous sheet: ${Math.round(width*100)} cm wide × ${cm} cm long (${cm*10} mm)\nPurchased area: ${area.toFixed(2)} m²` : 'Choose an available thickness and width, then enter a valid cut length.';
      q('[data-cut-total]').textContent = valid ? `Total: ${money(price * cm / step)} including VAT` : 'Enter a valid length to see your price';
      q('[data-cut-help]').textContent = `Order lengths in 10 cm increments, from ${minimum} to ${maximum} cm. ${width > 0 ? `Price: ${money(price * 10 / width)} per m² including VAT.` : ''}`;
      q('[data-cut-id]').value = select.value;
      q('[data-cut-qty]').value = valid ? cm / step : 0;
      q('[data-cut-property]').value = valid ? cm : '';
      q('[data-cut-mm]').value = valid ? cm*10 : '';
      q('[data-cut-spec]').value = opt?.dataset.spec || '';
      q('[data-cut-sheet]').value = valid ? `${Math.round(width*100)} cm × ${cm} cm — one continuous piece` : '';
      submit.disabled = !valid;
    }
    const requested = new URLSearchParams(location.search);
    const variant = requested.get('variant');
    if (variant && [...select.options].some(o => o.value === variant && o.dataset.available === 'true')) select.value = variant;
    const initial = select.selectedOptions[0];
    if (initial) { thickness.value = initial.dataset.thickness; rollWidth.value = initial.dataset.widthLabel; }
    const length = Number(requested.get('length_cm'));
    if (requested.has('length_cm') && Number.isInteger(length) && length >= minimum && length <= maximum && length % step === 0) input.value = length;
    thickness.addEventListener('change', update);
    rollWidth.addEventListener('change', update);
    input.addEventListener('input', update);
    q('[data-cut-form]').addEventListener('submit', e => {
      update();
      if (submit.disabled) { e.preventDefault(); return; }
      q('[data-cut-key]').value = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`;
      submit.disabled = true;
      submit.textContent = 'Adding your sheet…';
    });
    window.addEventListener('pageshow', () => { submit.textContent = 'Add one cut sheet to basket'; update(); });
    update();
  });
})();
